export default __webpack_public_path__ + "static/webApp-58362db7e38194b45dd538e9c0b9e2fb.jpg";